import { render } from "./HomeBanner.vue?vue&type=template&id=0839b54a&scoped=true"
import script from "./HomeBanner.vue?vue&type=script&lang=js"
export * from "./HomeBanner.vue?vue&type=script&lang=js"

import "./HomeBanner.vue?vue&type=style&index=0&id=0839b54a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0839b54a"]])

export default __exports__